<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "classes",
  data() {
    return {};
  },
  created() {}
};
</script>
